export const AUTO_REVIEW_CATEGORIES = [
    'interactive-states', 'form-quality', 'visual-consistency',
    'responsive-gaps', 'dead-ui', 'content-quality',
];
export const AUTO_REVIEW_CATEGORY_LABELS = {
    'visual-consistency': 'Design Inconsistencies',
    'interactive-states': 'Interactive States',
    'form-quality': 'Form Quality',
    'responsive-gaps': 'Responsive Gaps',
    'dead-ui': 'Dead UI',
    'content-quality': 'Content Quality',
};
// Category -> ticket type. The extension's export handoff renders this as a chip
// in the ExportModal and the server route stamps it onto the row, so two copies
// would let the chip disagree with what was persisted; both sides import this
// one. Reuses the existing report_type enum, so there is no new enum and no
// migration. Inconsistency + interactive-state findings are design DEBT; the
// rest are design BUGS.
export const AUTO_REVIEW_CATEGORY_TO_TICKET_TYPE = {
    'visual-consistency': 'design-debt',
    'interactive-states': 'design-debt',
    'form-quality': 'design-bug',
    'responsive-gaps': 'design-bug',
    'dead-ui': 'design-bug',
    'content-quality': 'design-bug',
};
export const AUTO_REVIEW_WIDTHS = [375, 768, 1280];
export const DEFAULT_AUTO_REVIEW_VIEWPORT = { width: 1280, height: 800 };
// checkInteractions is ON by default (Emily, 2026-10-08: "it should be on for
// all projects by default"). A project with no auto_review_settings row scans
// menus, keyboard focus and required-field recovery; a saved row can still turn
// it off once the Project scan options editor returns (SCAN_OPTIONS_EDITOR_HIDDEN).
export const DEFAULT_AUTO_REVIEW_SETTINGS = { additionalWidths: [], checkInteractions: true };
//# sourceMappingURL=autoReview.js.map